import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import ReactTable from 'react-table';
import { Grid, Form, Checkbox } from 'semantic-ui-react';
import moment from 'moment';

import { ReportFieldEnum } from 'Common/FieldEnum';
import { DatePickerField } from 'Common/SemanticWrapper';
import * as constants from 'Common/Constants';
import { SiteComponent } from 'Common/SiteComponent';
import { TitledCard } from 'Components';
import { BILLING_ACCOUNT_FORM_NAME } from 'Common/FormEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { DetailType, DetailTypeOptions } from '../constants';

class BillingAccountForm extends Component {
  state = {
    disableDetailChange: true,
    selectedIds: [],
    checkAllChecked: false,
    selectedSiteId: '',
  };

  detailChange = data => {
    if (data === 'List') {
      this.setState({ disableDetailChange: true });
    } else if (data === 'Details') {
      this.setState({ disableDetailChange: false });
    } else {
      this.setState({ disableDetailChange: true });
    }
  };

  siteChange = data => {
    if (this.state.selectedSiteId !== data) {
      this.props.getBillingList(data);
      this.setState({ checkAllChecked: false, selectedSiteId: data });
    }
  };

  render() {
    const { billingList, tableLoading, dispatch, formValues } = this.props;

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid style={{ paddingBottom: '10px' }}>
            <Grid.Row style={{ paddingBottom: '0px' }}>
              <Grid.Column>
                <div className="field">
                  <label>Detail Type</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={6} style={{ paddingTop: '0px' }}>
              <ReduxFormButtonGroup
                className={'btn-group--form'}
                dispatch={dispatch}
                formName={BILLING_ACCOUNT_FORM_NAME}
                fieldName={ReportFieldEnum.DetailType}
                options={DetailTypeOptions}
                value={formValues[ReportFieldEnum.DetailType]}
              />
            </Grid.Row>
            <Grid.Row columns={3}>
              <Grid.Column>
                <SiteComponent
                  name={ReportFieldEnum.Site}
                  onChange={this.siteChange}
                  {...this.props}
                  isForm={true}
                />
              </Grid.Column>
            </Grid.Row>
            {formValues[ReportFieldEnum.DetailType] === DetailType.Details && (
              <Fragment>
                <Grid.Row>
                  <Grid.Column>
                    <Field
                      name={ReportFieldEnum.FromDate}
                      component={DatePickerField}
                      type="text"
                      label="From"
                      openToDate={moment().add(-1, 'days')}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Field
                      name={ReportFieldEnum.ToDate}
                      component={DatePickerField}
                      type="text"
                      label="To"
                      openToDate={moment()}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Fragment>
            )}
            <Grid.Row>
              <Grid.Column
                computer={constants.COLUMN_RESPONSIVE_WIDTH_COMPUTER}
                widescreen={constants.COLUMN_RESPONSIVE_WIDTH_WIDESCREEN}
                largeScreen={constants.COLUMN_RESPONSIVE_WIDTH_LARGESCREEN}
              />
            </Grid.Row>
          </Grid>
        </TitledCard>
        <ReactTable
          minRows={billingList && billingList.length === 0 ? 5 : 0}
          data={billingList}
          defaultPageSize={5}
          className="-striped -highlight"
          sortable={false}
          columns={[
            {
              Header: 'NAME',
              accessor: 'FullName',
            },
            {
              Header: currentRows => {
                return (
                  <span>
                    <Checkbox
                      checked={this.state.checkAllChecked}
                      onClick={(e, data) => {
                        this.setState({
                          checkAllChecked: !this.state.checkAllChecked,
                        });
                        this.props.checkAll(
                          data.checked ? 1 : 0,
                          currentRows.data
                        );
                      }}
                    />
                  </span>
                );
              },

              accessor: 'Allowed',
              maxWidth: 120,
              sortable: false,
              Cell: ({ original }) => {
                return (
                  <div style={{ textAlign: 'center' }}>
                    <Checkbox
                      checked={original.Allowed === 1}
                      onChange={() => {
                        this.props.updateBillingData(original);
                        this.props.billingList.map((data, i) => {
                          if (data.Allowed === 0) {
                            this.setState({ checkAllChecked: false });
                          }
                          return null;
                        });
                      }}
                    />
                  </div>
                );
              },
            },
          ]}
          noDataText={
            !tableLoading && billingList.length === 0 ? 'No Data Found' : ''
          }
          loading={tableLoading}
          getProps={() => {
            return {
              style: {
                margin: '0px 0px',
              },
            };
          }}
        />
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values[ReportFieldEnum.DetailType]) {
    errors[ReportFieldEnum.DetailType] = 'Detail Type is required';
  }

  if (!values[ReportFieldEnum.Site]) {
    errors[ReportFieldEnum.Site] = 'site is required';
  }

  if (values[ReportFieldEnum.DetailType] === 'Details') {
    if (!values[ReportFieldEnum.FromDate]) {
      errors[ReportFieldEnum.FromDate] = 'From date is required';
    }
    if (!values[ReportFieldEnum.ToDate]) {
      errors[ReportFieldEnum.ToDate] = 'to date is required';
    }
  }

  return errors;
};

export default reduxForm({
  validate,
  form: BILLING_ACCOUNT_FORM_NAME,
})(BillingAccountForm);



// WEBPACK FOOTER //
// ./src/pages/billingaccount/components/BillingAccountForm.js